module.exports = __webpack_public_path__ + "static/media/password.008e4b75.png";